import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-project-viviendas-nav',
  templateUrl: './new-project-viviendas-nav.component.html',
  styleUrls: ['./new-project-viviendas-nav.component.css'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class NewProjectViviendasNavComponent {
  @Input() viviendasArray!: FormArray;
  @Input() activeViviendaIndex: number = 0;
  @Input() mainPropertyIndex: number = 0;
  @Output() viviendaChange = new EventEmitter<number>();
  @Output() addVivienda = new EventEmitter<void>();
  @Output() removeVivienda = new EventEmitter<number>();
  @Output() setMainProperty = new EventEmitter<number>();

  onViviendaSelect(index: number): void {
    this.viviendaChange.emit(index);
  }

  onSetMainProperty(index: number): void {
    this.setMainProperty.emit(index);
  }

  onAddVivienda(): void {
    this.addVivienda.emit();
  }

  onRemoveVivienda(index: number): void {
    this.removeVivienda.emit(index);
  }

  getViviendaName(index: number): string {
    const vivienda = this.viviendasArray.at(index);
    return vivienda?.get('name')?.value || `Property ${index + 1}`;
  }

  canRemoveVivienda(): boolean {
    return this.viviendasArray.length > 1;
  }
}
